export default {
    "quarterly": "Quarterly",
    "by-date": "By date",
    "divide-chart": "Divide chart",
    "start": "Start",
    "end": "End"
}